const EventEmitter = require('eventemitter3');

const _init = function (ui) {
    ui.btns = [...ui.el.querySelectorAll('[data-section-i]')];
    ui.items = ui.btns.map(btn => {
        return btn.parentNode;
    });
    ui.map = {};
    ui.values = ui.btns.map(btn => {
        return parseInt(btn.dataset.sectionI);
    });
    ui.selected = -1;

    let i;
    for (i = 0; i <  ui.values.length; i++) {
        ui.map[ui.values[i]] = i;
    }

    i = ui.el.dataset.selected || -1;
    ui._update(ui.values[i], i);

};

const _enable = function () {
    const ui = this;
    if (ui._enabled) return;
    ui.el.classList.add('active');
    _addEventListeners(ui);
    ui._enabled = true;
};

const _disable = function () {
    const ui = this;
    if (!ui._enabled) return;
    ui.el.classList.remove('active');
    _addEventListeners(ui, false);
    ui._enabled = false;
};

const _destroy = function () {
    const ui = this;
    ui.disable();
    ui.removeAllListeners();

    delete ui.el.data.uiController;
};

const _update = function (value, i) {
    const ui = this;
    if (typeof value === 'undefined' || i < 0 || i > ui.btns.length - 1) return;
    if (ui.selected > -1)
        ui.items[ui.selected].dataset.selected = false;
    ui.el.dataset.selected = ui.selected = i;
    ui.el.dataset.selectedId = ui.selectedId = value;
    ui.items[i].dataset.selected = true;
};

const _addEventListeners = function (ui, b) {

    if (b === false) {
        ui.btns.forEach((btn, i) => {
            btn.removeEventListener('click', ui._onClick[i]);
        });
        return;
    }

    ui._onClick = [];

    ui.btns.forEach((btn, i) => {

        const value = parseInt(btn.dataset.sectionI);
        const f = () => {
            if (typeof value === 'undefined') return;
            ui._update(value, i);
            ui.emit('changed', value);
        };
        ui._onClick.push(f);
        btn.addEventListener('click', f);
    });
};

module.exports = el => {

    if (el.data && el.data.uiController) return el.data.uiController;

    const ui = new EventEmitter();
    ui.el = el;

    ui.el.data = ui.el.data || {};
    ui.el.data.uiController = ui;

    ui.type = 'pagination';
    ui.enable = _enable.bind(ui);
    ui.disable = _disable.bind(ui);
    ui.destroy = _destroy.bind(ui);
    ui._update = _update.bind(ui);
    ui.getSelected = () => { return ui.selected; };
    ui.setSelected = i => {
        if (i < 0 || i > ui.values.length - 1) return ui.selected;
        ui._update(ui.values[i], i);
        return ui.selected;
    };
    ui.getValue = () => { return ui.selectedId; };
    ui.setValue = value => {
        if (!ui.map.hasOwnProperty(value)) return ui.selectedId;
        const i = ui.map[value];
        ui._update(value, i);
        return ui.selectedId;
    };

    _init(ui);

    return ui;
}


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/ui/Pagination.js